import { Theme } from '@mui/material/styles'

const useStyles = {
  endAdornment: (theme: Theme) => ({
    marginRight: theme.spacing(2),
  }),
  dropdown: (theme: Theme, disabled: boolean | undefined) => ({
    '& .MuiFilledInput-root': {
      backgroundColor: disabled ? theme.palette.ui.disabledStateColor : theme.palette.ui.surfaceContainerLow,
      '&.Mui-focused, &:hover': {
        backgroundColor: theme.palette.ui.surfaceContainerLow,
      },
    },
    '& .MuiInputLabel-filled,& .MuiInputLabel-filled.Mui-focused': {
      color: theme.palette.ui.onSecondaryFixed,
      opacity: 0.7,
    },
  }),
}

export default useStyles
